import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 获取航次列表(根据船名ID)
export function getVoyagesByVesselId(params) {
  return request({
    url: URL.mdm.getVoyagesByVesselId,
    method: 'get',
    params
  })
}

// 获取船期列表
export function queryShippingSchedule(data) {
  return request({
    url: URL.seaExport.queryShippingSchedule,
    method: 'post',
    data
  })
}

// 获取船期列表
export function getVoyageRouteCode() {
  return request({
    url: URL.seaExport.getVoyageRouteCode,
    method: 'get'
  })
}
// 根据船名获取航次信息列表
export function queryVoyages(params) {
  return request({
    url: URL.seaExport.queryVoyages,
    method: 'get',
    params
  })
}
// 根据船名获取航次信息列表
export function getSegments(params) {
  return request({
    url: URL.seaExport.getSegments,
    method: 'get',
    params
  })
}
// 保存航次信息
export function saveVoyages(data) {
  return request({
    url: URL.seaExport.saveVoyages,
    method: 'post',
    data
  })
}
// 删除航次信息
export function delVoyage(data) {
  return request({
    url: URL.seaExport.delVoyage,
    method: 'post',
    data
  })
}

// 获取当前是否改配
export function getVesselChangeStatus(data) {
  return request({
    url: URL.seaExport.getVesselChangeStatus,
    method: 'post',
    data: data
  })
}

// 写入清空或者不清空或忽略
export function changeVesselChangeStatus(params) {
  return request({
    url: URL.seaExport.changeVesselChangeStatus,
    method: 'get',
    params
  })
}

// 根据船名、航次、船司港口等信息查询对应的时间
export function loadingShipTime(params) {
  return request({
    url: URL.seaExport.loadingShipTime,
    method: 'get',
    params
  })
}
